export default __webpack_public_path__ + "static/media/my_photo3.ee2d7ab5.jpg";